const validateCollectionImage = (constants, file) => new Promise((resolve) => {
  const img = new Image();
  img.src = file;
  img.onload = () => {
    const result = {
      isValid: true,
      validationMessage: '',
    };

    if (constants.minHeight && img.height < constants.minHeight) {
      result.isValid = false;
      result.validationMessage = `Min height should be ${constants.minHeight}px`;
      resolve(result);
      return;
    }

    const imageRatio = (img.width / img.height).toFixed(2);

    if (
      constants.sourceRatio
      && constants.isNeedToValidateRatio
      && Math.abs(imageRatio - constants.sourceRatio) > 0.1
    ) {
      result.isValid = false;
      result.validationMessage = `Image ratio should be ${constants.sourceRatioText}`;
      resolve(result);
      return;
    }

    resolve(result);
  };
});

export const validateImageFile = (file, constants) => {
  const result = {
    isValid: true,
    validationMessage: '',
  };

  const allowedFormats = constants.allowedFormats || ['png', 'jpeg', 'jpg'];
  const fileExtension = file.name.split('.').pop().toLowerCase();

  const isValidFormat = allowedFormats.some((format) => {
    const normalizedFormat = format.toLowerCase() === 'jpeg' ? 'jpg' : format.toLowerCase();
    return fileExtension === normalizedFormat
      || (normalizedFormat === 'jpg' && fileExtension === 'jpeg');
  });

  if (!isValidFormat) {
    result.isValid = false;
    const formatsText = allowedFormats.map((f) => f.toUpperCase()).join(', ');
    result.validationMessage = `File format should be ${formatsText}`;
    return result;
  }

  if (constants.maxSize && ((file.size / 1024) / 1024) > constants.maxSize) {
    result.isValid = false;
    result.validationMessage = `File size can be no more than ${constants.maxSize} MB`;
    return result;
  }

  return result;
};

export const imageConstraints = {
  'collection-titleImage': {
    allowedFormats: ['png'],
    minWidth: 100,
    minHeight: 120,
    maxSize: 10,
    title: 'Title Image',
    sourceRatio: 1,
    isNeedToValidateRatio: false,
    sourceRatioText: '1:1',
    wrapperWidth: '340px',
    wrapperHeight: '260px',
  },
  'collection-posterImage': {
    allowedFormats: ['png', 'jpeg', 'jpg'],
    minWidth: null,
    minHeight: 1080,
    maxSize: 10,
    title: 'Poster Image (16:9)',
    sourceRatio: (16 / 9).toFixed(2),
    isNeedToValidateRatio: true,
    sourceRatioText: '16:9',
    wrapperWidth: '460px',
    wrapperHeight: '260px',
  },
  'collection-portraitImage': {
    allowedFormats: ['png', 'jpeg', 'jpg'],
    minWidth: null,
    minHeight: 1080,
    maxSize: 10,
    title: 'Poster Image (2:3)',
    sourceRatio: (2 / 3).toFixed(2),
    isNeedToValidateRatio: true,
    sourceRatioText: '2:3',
    wrapperWidth: '260px',
    wrapperHeight: '390px',
  },
  'collection-backgroundImage': {
    allowedFormats: ['png', 'jpeg', 'jpg'],
    minWidth: null,
    minHeight: 1080,
    maxSize: 10,
    title: 'Background Image (16:9)',
    sourceRatio: (16 / 9).toFixed(2),
    isNeedToValidateRatio: true,
    sourceRatioText: '16:9',
    wrapperWidth: '460px',
    wrapperHeight: '260px',
  },
  'collection-backgroundImage2x3': {
    allowedFormats: ['png', 'jpeg', 'jpg'],
    minWidth: null,
    minHeight: 1080,
    maxSize: 10,
    title: 'Background Image (2:3)',
    sourceRatio: (2 / 3).toFixed(2),
    isNeedToValidateRatio: true,
    sourceRatioText: '2:3',
    wrapperWidth: '260px',
    wrapperHeight: '390px',
  },
  'assets-static-posterImage': {
    assetRole: {
      name: 'Poster Image (16:9)',
      shortName: 'posterImage16x9',
    },
    styles: {
      'aspect-ratio': '16/9',
    },
    id: 'posterImage16x9',
    shortName: 'posterImage16x9',
    canDelete: false,
    canEdit: true,
    dimensions: '1280x720',
    entityType: 'supplemental file',
    isAnyPoster: true,
    type: 'image',
    url: '',
  },
  'assets-static-posterImage2x3': {
    assetRole: {
      name: 'Poster Image (2:3)',
      shortName: 'posterImage2x3',
    },
    styles: {
      'aspect-ratio': '2/3',
      height: '100%',
    },
    id: 'posterImage2x3',
    shortName: 'posterImage2x3',
    canDelete: false,
    canEdit: true,
    dimensions: '720x1080',
    entityType: 'supplemental file',
    isAnyPoster: true,
    type: 'image',
    url: '',
  },
  'assets-static-posterImage9x16': {
    assetRole: {
      name: 'Poster Image (9:16)',
      shortName: 'posterImage9x16',
    },
    styles: {
      'aspect-ratio': '9/16',
      height: '100%',
    },
    id: 'posterImage9x16',
    shortName: 'posterImage9x16',
    canDelete: false,
    canEdit: true,
    dimensions: '720x1280',
    entityType: 'supplemental file',
    isAnyPoster: true,
    type: 'image',
    url: '',
  },
};

export const afterLoadValidationFunctionMap = {
  'collection-titleImage': validateCollectionImage
    .bind(null, imageConstraints['collection-titleImage']),
  'collection-posterImage': validateCollectionImage
    .bind(null, imageConstraints['collection-posterImage']),
  'collection-portraitImage': validateCollectionImage
    .bind(null, imageConstraints['collection-portraitImage']),
  'collection-backgroundImage': validateCollectionImage
    .bind(null, imageConstraints['collection-backgroundImage']),
  'collection-backgroundImage2x3': validateCollectionImage
    .bind(null, imageConstraints['collection-backgroundImage2x3']),
};
